import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/rhythm/banner.jpg'
import navColor from '../../assets/rhythm/nav/color.jpg'
import navBgFixed from '../../assets/rhythm/nav/nav_bg_fixed.png'

import far1 from '../../assets/rhythm/nav/far1.png'
import far1_active from '../../assets/rhythm/nav/far1_active.png'
import far2 from '../../assets/rhythm/nav/far2.png'
import far2_active from '../../assets/rhythm/nav/far2_active.png'
import far3 from '../../assets/rhythm/nav/far3.png'
import far3_active from '../../assets/rhythm/nav/far3_active.png'

import son1 from '../../assets/rhythm/nav/son1.png'
import son1_active from '../../assets/rhythm/nav/son1_active.png'
import son2 from '../../assets/rhythm/nav/son2.png'
import son2_active from '../../assets/rhythm/nav/son2_active.png'
import son3 from '../../assets/rhythm/nav/son3.png'
import son3_active from '../../assets/rhythm/nav/son3_active.png'
import son4 from '../../assets/rhythm/nav/son4.png'
import son4_active from '../../assets/rhythm/nav/son4_active.png'
import son5 from '../../assets/rhythm/nav/son5.png'
import son5_active from '../../assets/rhythm/nav/son5_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(108),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtnFixed: {
    height: calcRemFn(110),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `${calcRemFn(10)} ${calcRemFn(44)} 0 ${calcRemFn(42)}`,
  },
  topBtnBaseCss: {
    padding: `${calcRemFn(13)} ${calcRemFn(20)} 0`,
    width: calcRemFn(36),
    height: calcRemFn(31)
  },
  bottomBtnLayout: {
    justifyContent: 'center',
    padding: `${calcRemFn(4)} ${calcRemFn(40)} 0`,
  },
  bottomBtnBaseCss: {
    padding: `${calcRemFn(8)} ${calcRemFn(10)} 0`,
    width: calcRemFn(46),
    height: calcRemFn(22.5)
  }
}

const navData = {
  // rhythmSpec: true,
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active
      },
      {
        key: '_i5',
        show: true,
        img: son5,
        img_actived: son5_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ]
  }
}

const pictureList = [
  {
    key: '1_1',
    pid: 102562
  },
  {
    key: '1_2',
    pid: 102562
  },
  {
    key: '1_3',
    pid: 102562
  },
  {
    key: '1_4',
    pid: 102562
  },
  {
    key: '1_5',
    pid: 102562
  },
  {
    key: '2_1',
    pid: 102563
  },
  {
    key: '2_2',
    pid: 102563
  },
  {
    key: '2_3',
    pid: 102563
  },
  {
    key: '2_4',
    pid: 102563
  },
  {
    key: '3_1',
    pid: 102564
  },
  {
    key: '3_2',
    pid: 102564
  },
  {
    key: '3_3',
    pid: 102564
  },
  {
    key: '3_4',
    pid: 102564
  }
]

function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum = 2, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/rhythm/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'gold',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)
pictures.push({
  id: '',
  type: 'gold',
  son: [require(`../../assets/rhythm/ctn/end.jpg`)]
})

const topDiff = {
  firstSon: '_i1',
  top1_i1: 30,
  top1_i2: 30,
  top1_i3: 30,
  top1_i4: 30,
  top1_i5: 30,
  top2_i1: 50,
  top2_i2: 30,
  top2_i3: 30,
  top2_i4: 30,
  top3_i1: 50,
  top3_i2: 30,
  top3_i3: 30,
  top3_i4: 30,
}

export default {
  title: '运动照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
